export default defineNuxtPlugin((nuxtApp) => {
  
  const config = useRuntimeConfig()
     
  
    const api = $fetch.create({
      baseURL: process.server ? config.apiInternalBase : config.public.API_BASE_URL_WEB,
      headers: {
        'content-type': 'application/json'
      },
       credentials: 'omit'
    })
  
    // Expose to useNuxtApp().$api
    return {
      provide: {
        api
      }
    }
  })
  
